import {AxiosResponse} from "axios"
import {observable} from "mobx"
import ApiService from "../../../services/ApiService"
import {GroupId} from "../../../validation/ValidPrimaryKey"
import {GroupInfo} from "./models/GroupInfo"
import {GroupMaster, ManageGroupsGroupMasterCronDTO} from "./models/GroupMaster"

class GroupMasterStore {

    @observable
    defaultGroup?: GroupMaster = undefined

    @observable
    currentSubGroups?: GroupMaster[] = undefined

    @observable
    groupInfo?: GroupInfo = undefined

    findGroupInfo = (id: number) => {
        ApiService.get(`${this.url()}/${id}/test-taker-info`).then(
            (response: AxiosResponse<GroupInfo>) => {
                this.groupInfo = response.data
            }
        )
    }

    findDistrictReportGroupInfo = (id: number) => {
        ApiService.get(`${this.url()}/${id}/districtinfo`).then(
            (response: AxiosResponse<GroupInfo>) => {
                this.groupInfo = response.data
            }
        )
    }

    selectGroup = (id: number) => {
        ApiService.get(`${this.url()}/${id}/select`).then(
            (response: AxiosResponse<GroupMaster>) => {
                this.defaultGroup = response.data
            }
        )
    }

    findDefaultGroup = () => {
        ApiService.get(`${this.url()}`).then(
            (response: AxiosResponse<GroupMaster>) => {
                this.defaultGroup = response.data
            }
        )
    }

    findDefaultSAMLGroup = (productId: number) => {
        ApiService.get(`${this.url()}/saml-groups/${productId}`).then(
            (response: AxiosResponse<GroupMaster>) => {
                this.defaultGroup = response.data
            }
        )
    }

    getGroupById = (groupId: GroupId): Promise<ManageGroupsGroupMasterCronDTO> => {
        return ApiService.get(`${this.url()}/${groupId}/select`).then((r: AxiosResponse) => {
                // TODO: Resolve this data inconsistency
                this.defaultGroup = r.data // Here we expect r.data to be of type GroupMaster
                return r.data // Here we expect r.data to be of type ManageGroupsGroupMasterCronDTO... which is it?
            }
        )
    }

    // TODO: Make this not return a promise, the CST TakeSearch.tsx file would need to be refactored pretty
    // dramatically to make that work, but we should do that soon.
    getSubGroupsForGroup = (parentId: GroupId | null): Promise<GroupMaster[]> => {
        let queryUrl: string
        if (parentId === null) {
            queryUrl = `${this.url()}/root/subgroups`
        }
        else {
            queryUrl = `${this.url()}/${parentId}/subgroups`
        }
        return ApiService.get(queryUrl).then((response: AxiosResponse) => {
            this.currentSubGroups = response.data
            return response.data
        })
    }

    getSubGroupsForGroupCron = (parentId: GroupId | null): Promise<ManageGroupsGroupMasterCronDTO[]> => {
        let queryUrl: string
        if (parentId === null) {
            queryUrl = `${this.url()}/root/subgroupscron`
        }
        else {
            queryUrl = `${this.url()}/${parentId}/subgroupscron`
        }
        return ApiService.get(queryUrl).then((response: AxiosResponse) => {
            this.currentSubGroups = response.data
            return response.data
        })
    }

    createGroup = (name: string, parentGroupId: number | null, groupType: string): Promise<GroupMaster> => {
        let queryUrl: string
        if (parentGroupId === null) {
            queryUrl = `${this.url()}/creategroup/root/${groupType}/${name}`
        }
        else {
            queryUrl = `${this.url()}/creategroup/${parentGroupId}/${groupType}/${name}`
        }
        return ApiService.get(queryUrl).then((response: AxiosResponse) => response.data)
    }

    renameGroup = (name: string, groupId: number): Promise<ManageGroupsGroupMasterCronDTO> => {
        let queryUrl: string = `${this.url()}/renamegroup/${groupId}/${name}`
        return ApiService.get(queryUrl).then((response: AxiosResponse) => response.data)
    }

    mergeGroups = (receiverGroupId: number, donorGroupId: number): Promise<number> => {
        let queryUrl: string = `${this.url()}/mergegroups/${receiverGroupId}/${donorGroupId}`
        return ApiService.get(queryUrl).then((response: AxiosResponse) => response.data)
    }

    editTestSettingsProperty = (groupId: number, propertyName: string, propertyValueString: string): Promise<number> => {
        let queryUrl: string = `${this.url()}/edittestsettings/${groupId}/${propertyName}/${propertyValueString}`
        return ApiService.get(queryUrl).then((response: AxiosResponse) => response.data)
    }

    private url = () => `${ApiService.API_URL}groupmasters`
}

export const groupMasterStore = new GroupMasterStore()
